import React from 'react';
import { Form, Header } from 'semantic-ui-react';
import RichTextEditor from '../../RichTextEditor';
import Metadata from '../Metadata';

const details = ({ obj, language, onChange }) => {
  return (
    <div>
      <Header as="h3">
        Bloc important de l'enseigne ({language.language})
      </Header>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton"
          id="importantCtaLabel"
          value={obj.translations[language.id].importantCtaLabel}
          fluid
          label="Label du bouton"
          onChange={(e) => onChange(e, language.id)}
        />
        <Form.Input
          placeholder="https://..."
          id="importantCtaUrl"
          value={obj.translations[language.id].importantCtaUrl}
          fluid
          label="Adresse cible"
          onChange={(e) => onChange(e, language.id)}
        />
      </Form.Group>
      <Form.Field>
        <label>Texte</label>
        <RichTextEditor
          id="importantTexte"
          value={obj.translations[language.id].importantTexte}
          placeholder="Texte"
          onChange={(e) => onChange(e, language.id)}
        />
      </Form.Field>
      <Header as="h3">Bloc contenu de l'enseigne ({language.language})</Header>
      <Form.Field>
        <Form.Input
          label="Titre"
          placeholder="Titre"
          id="title"
          value={obj.translations[language.id].title}
          onChange={(e) => onChange(e, language.id)}
        />
      </Form.Field>
      <Form.Field>
        <label>Contenu</label>
        <RichTextEditor
          id="content"
          placeholder="Contenu"
          value={obj.translations[language.id].content}
          onChange={(e) => onChange(e, language.id)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton"
          id="ctaLabel"
          fluid
          label="Label du bouton"
          value={obj.translations[language.id].ctaLabel}
          onChange={(e) => onChange(e, language.id)}
        />
        <Form.Input
          placeholder="https://..."
          id="ctaUrl"
          fluid
          label="Adresse cible"
          value={obj.translations[language.id].ctaUrl}
          onChange={(e) => onChange(e, language.id)}
        />
      </Form.Group>
      <Header as="h3">Bloc horaire de l'enseigne ({language.language})</Header>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton"
          id="ttCtaLabel"
          fluid
          label="Label du bouton"
          value={obj.translations[language.id].ttCtaLabel}
          onChange={(e) => onChange(e, language.id)}
        />
        <Form.Input
          placeholder="https://..."
          id="ttCtaUrl"
          fluid
          label="Adresse cible"
          value={obj.translations[language.id].ttCtaUrl}
          onChange={(e) => onChange(e, language.id)}
        />
      </Form.Group>
      <Form.Field>
        <label>Texte</label>
        <RichTextEditor
          id="ttTexte"
          placeholder="Texte"
          value={obj.translations[language.id].ttTexte}
          onChange={(e) => onChange(e, language.id)}
        />
      </Form.Field>

      <br />
      <Metadata
        obj={obj}
        language={language}
        onChange={onChange}
        legacy={true}
      />
    </div>
  );
};

export default details;



// WEBPACK FOOTER //
// ./src/components/form/shop/details.js